import { render, staticRenderFns } from "./AiMenu.vue?vue&type=template&id=5e1a9e76"
import script from "./AiMenu.vue?vue&type=script&lang=js"
export * from "./AiMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports